export default "__VITE_ASSET__CeTxveZR__"